// Events
import { MODAL_CLOSE, MODAL_OPEN, STICKY_FOOTER_TOGGLE_SECTION } from 'events';
import { component } from 'picoapp';

export default component((node, ctx) => {
  const { type, stopPropagation = 'true', modalId, modalProps, formId, productId } = node.dataset;

  let hasError = false;

  node.addEventListener('product:form:submit-error', (event) => {
    if (stopPropagation === 'true') event.stopPropagation();

    hasError = true;

    switch (type) {
      // When the size hasn't been selected but the customer tries to add it to the cart anyways, we capture the form error here and emit the modal open event. Then after selecting the size we immediately add it to the cart
      case 'PRODUCT_FORM_MODAL':
        ctx.emit(MODAL_OPEN, null, {
          id: modalId,
          props: JSON.parse(modalProps),
        });

        /** If the size modal is closed by the user, we need to set 'hasError' to false again. Otherwise when the
         * customer manually opens the size selector, the selected size will automatically be added to the cart, which
         * should only happen if the size selector is opened by clicking the add to cart (which trigger the form error)  */
        document.addEventListener('modal:closed', function handleModalClosed(e) {
          if (e.detail.id !== modalId) return;

          hasError = false;
          document.removeEventListener('modal:closed', handleModalClosed);
        });

        break;
      case 'PRODUCT_STICKY_FORM':
        ctx.emit(STICKY_FOOTER_TOGGLE_SECTION, null, 'sizes'); // Opens the sizes section on the sticky footer form when a size hasn't been selected and the customer pressed on 'add to cart'

        /** Same issue as with the modal. If the customer closes the section on the sticky footer, we have
         * to prevent that a product will be added automatically to the cart when they manually open it themselves
         * and select a size */
        document.addEventListener(
          'sticky-footer-section-closed',
          () => {
            hasError = false;
          },
          { once: true },
        );
        break;
      default:
        break;
    }
  });

  node.addEventListener('product:form:variant-selected', (e) => {
    if (stopPropagation === 'true') e.stopPropagation();

    switch (type) {
      case 'PRODUCT_FORM_MODAL':
        ctx.emit(MODAL_CLOSE, null, {
          id: modalId,
          props: JSON.parse(modalProps),
        });

        /** Is triggered when
         * 1. Customer clicks on add to cart but they haven't selected a size
         * 2. The customer selects a size from the size selected which was automatically opened because they tried to add a product without a size to the cart
         * 3. The if statement below is executed and the product is added to the cart
         */
        if (hasError && e.detail.variant.available)
          node.dispatchEvent(
            new CustomEvent(`${productId}:${formId}:submit`, { bubbles: true, cancelable: true }),
          );
        break;
      case 'PRODUCT_STICKY_FORM':
        ctx.emit(STICKY_FOOTER_TOGGLE_SECTION, null, 'sizes');

        if (hasError && e.detail.variant.available) {
          node.dispatchEvent(
            new CustomEvent(`${productId}:${formId}:submit`, { bubbles: true, cancelable: true }),
          );
        }
        break;
      default:
        break;
    }

    hasError = false;
  });
});
